(function ($) {
  $(document).ready(function () {
    /* Fix so that landing one-page links work on subpages */
    $("body #masthead a:not(.hamburger-holder):not(.search-global )").on("click", function (event) {
      if ($(this).attr("href").includes("#")) {
        var url = window.location.origin + window.location.pathname;
        var baseHref = $(this).attr("href").split("#")[0];
        if (url === baseHref) {
          event.preventDefault();
          var href = "#" + $(this).attr("href").split("#")[1];

          if ($(href).length) {
            $("html, body").animate(
              {
                scrollTop: $(href).offset().top,
              },
              500,
              function () {
                window.location.hash = href;
              }
            );
          }

          return false;
        } else {
          window.location = $(this).attr("href");
        }
      }
    });
    // Language select
    $("#lt-search-bar-ul li").on("click", function (event) {
      const newLang = $(this).data("lang");
      const parentUL = $(this).parent();
      // menu open - set new lang
      if (parentUL.hasClass("open")) {
        // set lang value for input hidden
        parentUL.parent().children("input[name='lang']").val(newLang);
        // close menu
        parentUL.removeClass("open");
        parentUL.find("li").removeClass("active");
        $(this).addClass("active");
        // open menu
      } else {
        parentUL.addClass("open");
      }
    });
    // Play sound on card click
    $("a.vards__play").on("click",function(event){
      var play_id = $(this).attr("play_id");
      document.getElementById(play_id).play();
    });

    // meklēšanas rezultātu skats
    // vārdšķiras modal
    $("#lt-search-results a.vtips").click(function(e) {
      e.preventDefault();
      var url = $(this).attr("href");
      jQuery.ajax({
        type: "GET",
        url: url,
        success: function(res) {
          if (res == 'nav_locijumi') return;
          jQuery('#formasModal .formasModal_modal_body').html(res);
          jQuery('#formasModal').modal('show');
        },
        error: function(request, status, error) {
          console.log(error);
        }
      });
    });

    // resize on show map
    jQuery('#mapModal').on('shown.bs.modal', async function(e) {
      // sleep for 1 sec
      await new Promise(r => setTimeout(r, 1000));
      window.dispatchEvent(new Event('resize'));
    })

    // atveram karti
    $("#lt-search-results a.lt-btn--map").click(async function(e) {
      e.preventDefault();
      const vards_id = $(this).attr("vards_id");
      
      // create map for first time - editor is set as global variable
      if (!mapObject) {
        mapObject = new jsGeomEditor({id: 'drawMap'});
        console.log("create map");
      } else {
        mapObject.clear();
        console.log("clear map");
      }
      
      // draw map
		  mapObject.add(vietvardi_geo[vards_id]);
      jQuery('#mapModal').modal('show');
    });
  });

})(jQuery);
